module.exports = __webpack_public_path__ + "static/media/progman_29.77d4667b.ico";